<template>
  <div v-if="someIncomplete" id="some-position-incomplete-warning">
    <v-alert color="softWarning" icon="mdi-alert" class="mt-3 mb-2">
      {{ $t(`views.common.somePositionIncomplete.incomplete`) }}
    </v-alert>
  </div>
</template>

<script>
import { getPositionsLean } from '@/lib/api.js'

export default {
  props: {
    autoLoad: {
      type: Boolean,
      default: true,
    },
    positionSummaryDetail: {
      type: Object,
      default: null,
    },
  },
  data() {
    return {
      someIncomplete: false,
    }
  },
  watch: {
    positionSummaryDetail() {
      if (this.positionSummaryDetail) {
        this.someIncomplete = this.positionSummaryDetail.someIncomplete
      }
    },
  },
  async created() {
    if (this.autoLoad) {
      const result = await getPositionsLean({
        filter: {
          positionNumber: { $ne: 0 },
        },
      })
      const positions = result.data
      this.someIncomplete =
        positions && positions.length && positions.some((position) => position.incomplete)
    }
  },
}
</script>

<style></style>
